import { render, staticRenderFns } from "./LpsCovidFreeShipping.vue?vue&type=template&id=56c62980&scoped=true&lang=pug&"
import script from "./LpsCovidFreeShipping.vue?vue&type=script&lang=js&"
export * from "./LpsCovidFreeShipping.vue?vue&type=script&lang=js&"
import style0 from "./LpsCovidFreeShipping.vue?vue&type=style&index=0&id=56c62980&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c62980",
  null
  
)

export default component.exports